/** Session identity. One id per guest attempt; a retake keeps the same id. */

export function newSessionId(): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  // Older Android WebViews may not have randomUUID.
  const rand = Math.random().toString(36).slice(2, 10);
  return `s-${Date.now().toString(36)}-${rand}`;
}
